import React, { useState, useEffect } from 'react';
import SideBar from './Components/SideBar'; 
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DatabaseUtil from './Util/DatabaseUtil';
import Panels from './Components/Panels'; 

const DashUserSummary = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [userDetailsList, setUserDetailsList] = useState([]); 
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAllUserDetails = async () => {
            try {
                setLoading(true);
                const detailsList = await DatabaseUtil.getAllUsersDetails();
                setUserDetailsList(detailsList);
            } catch (error) {
                console.error('Failed to fetch all user details:', error);
                setError('Failed to load user details.');
            } finally {
                setLoading(false);
            }
        };

        fetchAllUserDetails();
    }, []);

    return (
        <>
            <SideBar />
            <div 
                style={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <h2 style={{ marginBottom: '20px',  fontFamily: 'KomikaAxis', color: 'var(--primary-color)' }}>{t('usersSidebar')}</h2>
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>{error}</p>
                ) : (
                    <div 
                        style={{ 
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '20px',
                            width: '60%',
                            margin: '0 auto',
                        }}
                    >
                        {userDetailsList.map((userDetails, index) => (
                            <Panels 
                                type="user"
                                key={index}
                                userDetails={userDetails} 
                                onClick={() => navigate(`/userdetail/${encodeURIComponent(userDetails.userName)}`)}
                                style={{
                                    width: '100%',
                                    maxWidth: 'none',
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default DashUserSummary;
